import { render, staticRenderFns } from "./index.vue?vue&type=template&id=30f379fd&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=30f379fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f379fd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsAsideCategories: require('/web/components/objects/AsideCategories.vue').default,CategoriesFilter: require('/web/components/CategoriesFilter.vue').default})
